export var ValidationErrorCode;
(function (ValidationErrorCode) {
    ValidationErrorCode[ValidationErrorCode["string_length"] = 0] = "string_length";
    ValidationErrorCode[ValidationErrorCode["string_min"] = 1] = "string_min";
    ValidationErrorCode[ValidationErrorCode["string_max"] = 2] = "string_max";
    ValidationErrorCode[ValidationErrorCode["num_min"] = 3] = "num_min";
    ValidationErrorCode[ValidationErrorCode["num_max"] = 4] = "num_max";
    ValidationErrorCode[ValidationErrorCode["one_of"] = 5] = "one_of";
})(ValidationErrorCode || (ValidationErrorCode = {}));
//# sourceMappingURL=validations.js.map